import './Hero.css';

interface Props {
  onRequestClick?: () => void;
}

export function Hero(props: Props) {
  return (
    <section class="hero" id="top">
      <div class="hero__video-wrap" aria-hidden="true">
        <video
          class="hero__video"
          autoplay
          muted
          loop
          playsinline
          preload="auto"
          poster="/hero-poster.jpg"
        >
          <source src="/hero.mp4" type="video/mp4" />
        </video>
      </div>

      <div class="container hero__inner">
        <div class="hero__content">
          <div class="eyebrow"><span class="hero__mark">Концепт 13 · Поставка с 2014 года</span></div>
          <h1 class="hero__title">
            <span class="hero__mark">
              Запчасти и&nbsp;агрегаты для&nbsp;грузовиков и&nbsp;спецтехники по&nbsp;всей России
            </span>
          </h1>

          <p class="hero__accent">
            <span class="hero__accent-dot" />
            <span class="hero__accent-text">
              Подберём подходящий агрегат{' '}
              <strong class="hero__accent-emphasis">
                по&nbsp;ЛУЧШЕЙ ЦЕНЕ
              </strong>{' '}
              в&nbsp;течение 1&nbsp;рабочего дня.
            </span>
          </p>

          <div class="hero__cta">
            <button class="btn btn--red" onClick={props.onRequestClick}>
              Подобрать агрегат <span class="btn__arrow">→</span>
            </button>
          </div>

          <p class="hero__note">
            <span class="hero__mark">
              Для точного подбора пришлите VIN, номер двигателя или фотографию шильдика.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
}
